import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Modal } from "@/components/common";
import { APP_NAME, APP_VERSION } from "@/config/constants";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
        <div className="w-full px-6 lg:px-8 py-6">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center gap-4">
              <p className="text-sm text-gray-600">
                © {currentYear} {APP_NAME}. All rights reserved.
              </p>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary-100 text-primary-700 text-xs font-semibold shadow-sm">
                Version {APP_VERSION}
              </div>
            </div>
            <div className="flex gap-6">
              <button
                onClick={() => setShowContactModal(true)}
                className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
              >
                联系我们
              </button>
              <Link
                to="/privacy"
                className="text-sm text-gray-600 hover:text-primary-600"
              >
                隐私政策
              </Link>
              <Link
                to="/terms"
                className="text-sm text-gray-600 hover:text-primary-600"
              >
                服务条款
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {/* 联系我们模态框 */}
      <Modal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
        title="联系我们"
      >
        <div className="text-center py-6">
          <Mail className="w-16 h-16 mx-auto mb-4 text-blue-600" />
          <p className="text-sm text-gray-600 mb-4">
            如有任何问题或建议，欢迎通过邮箱联系我们
          </p>
          <a
            href="mailto:jtwei001@gmail.com"
            className="text-lg font-medium text-blue-600 hover:text-blue-700 transition-colors"
          >
            jtwei001@gmail.com
          </a>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
